import * as Highcharts from 'highcharts';

import { Injectable } from '@angular/core';
import { I18nService } from './i18n.service';

@Injectable()
export class InvestmentChartOptionsService {
  constructor(private i18n: I18nService) {
  }

  /**
   * Returns the common highchart options for investment based chart
   */
  public getCommonOptions(): Highcharts.Options {
    const i18n = this.i18n;

    return {
      colors: ['#c9e2b8', '#6ba543', '#ffd54f', '#f4b183'],
      title: {
        text: null,
      },
      legend: {
        align: 'center',
        verticalAlign: 'top',
        itemStyle: {
          fontWeight: 'normal',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: null,
        },
        labels: {
          formatter: function () {
            // @ts-ignore
            return i18n.formatCurrency(this.value);
          },
        },
        stackLabels: {
          style: {
            fontWeight: 'normal',
          },
          x: 10,
          enabled: true,
          formatter: function () {
            // @ts-ignore
            return i18n.formatCurrency(this.total);
          },
        },
      },
    };
  }
}
